import axios from 'axios';
import { apiRest } from './constants';
const api = axios.create({ baseURL: apiRest, withCredentials: true });
const request = async callback => {
  try { return (await callback()).data; }
  catch (error) { return { error: true, message: typeof error.response?.data?.message === 'string' ? error.response.data.message : 'No se pudo completar la petición. Revisa la conexión y vuelve a intentarlo.' }; }
};
export const getControlUsers = params => request(() => api.get('control-users', { params }));
export const createControlUser = data => request(() => api.post('control-users', data));
